module.exports = __webpack_public_path__ + "static/Sample-4-e5e84bf22641583a35ef7f20215af576.png";